import { render, staticRenderFns } from "./gj-link.vue?vue&type=template&id=b582f7b0&scoped=true&"
import script from "./gj-link.vue?vue&type=script&lang=js&"
export * from "./gj-link.vue?vue&type=script&lang=js&"
import style0 from "./gj-link.vue?vue&type=style&index=0&id=b582f7b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b582f7b0",
  null
  
)

export default component.exports